import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { 
    forgotPasswordReducer, 
    profileReducer, 
    userReducer, 
    allUsersReducer, 
    userDetailsReducer 
} from './reducers/userReducer';
import { 
    newProductReducer, 
    newReviewReducer, 
    productDetailsReducer, 
    productReducer, 
    productsReducer, 
    productReviewsReducer, 
    reviewReducer 
} from './reducers/productReducer';
import { cartReducer } from './reducers/cartReducer';
import { saveForLaterReducer } from './reducers/saveForLaterReducer';
import { 
    allOrdersReducer, 
    myOrdersReducer, 
    newOrderReducer, 
    orderDetailsReducer, 
    orderReducer, 
    paymentStatusReducer 
} from './reducers/orderReducer';
import { wishlistReducer } from './reducers/wishlistReducer';

// Initial state function to minimize repetitive access to localStorage
const getInitialState = () => {
    const cartItems = localStorage.getItem('cartItems');
    const shippingInfo = localStorage.getItem('shippingInfo');
    const saveForLaterItems = localStorage.getItem('saveForLaterItems');
    const wishlistItems = localStorage.getItem('wishlistItems');

    return {
        cart: {
            cartItems: cartItems ? JSON.parse(cartItems) : [],
            shippingInfo: shippingInfo ? JSON.parse(shippingInfo) : {},
        },
        saveForLater: {
            saveForLaterItems: saveForLaterItems ? JSON.parse(saveForLaterItems) : [],
        },
        wishlist: {
            wishlistItems: wishlistItems ? JSON.parse(wishlistItems) : [],
        },
    };
};

const initialState = getInitialState();

// Combine reducers
const reducer = combineReducers({
    user: userReducer,
    profile: profileReducer,
    forgotPassword: forgotPasswordReducer,
    products: productsReducer,
    productDetails: productDetailsReducer,
    newReview: newReviewReducer,
    cart: cartReducer,
    saveForLater: saveForLaterReducer,
    newOrder: newOrderReducer,
    myOrders: myOrdersReducer,
    paymentStatus: paymentStatusReducer,
    orderDetails: orderDetailsReducer,
    allOrders: allOrdersReducer,
    order: orderReducer,
    newProduct: newProductReducer,
    product: productReducer,
    users: allUsersReducer,
    userDetails: userDetailsReducer,
    reviews: productReviewsReducer,
    review: reviewReducer,
    wishlist: wishlistReducer,
});

// Apply middleware (Thunks are used here for async actions)
const middleware = [thunk];

// Apply Redux DevTools only in development mode
const isDevelopment = process.env.NODE_ENV === 'development';
const store = createStore(
    reducer,
    initialState,
    isDevelopment ? composeWithDevTools(applyMiddleware(...middleware)) : applyMiddleware(...middleware)
);

export default store;
